import React from 'react';
import { LuX } from 'react-icons/lu';

// Lugares de la vista que todavía no tienen ubicación: tocar uno → marcarlo en el mapa.
export default function SinUbicarSheet({ lista, onCerrar, onElegir }) {
    return (
        <div className="fixed inset-0 z-[2000] bg-black/60 flex items-end md:items-center justify-center md:p-6" onClick={onCerrar}>
            <div className="w-full md:max-w-lg max-h-[80vh] bg-card rounded-t-3xl md:rounded-3xl flex flex-col overflow-hidden" onClick={e => e.stopPropagation()}>
                <div className="px-5 pt-4 pb-3 border-b border-black/[0.06] dark:border-white/[0.06] flex items-center gap-3">
                    <div className="flex-1">
                        <p className="text-body-lg font-black text-ink">Sin ubicar ({lista.length})</p>
                        <p className="text-caption text-muted">Tocá una y después marcala en el mapa</p>
                    </div>
                    <button type="button" onClick={onCerrar} aria-label="Cerrar" className="w-9 h-9 rounded-xl bg-chip text-muted flex items-center justify-center"><LuX size={17} /></button>
                </div>
                <div className="overflow-y-auto divide-y divide-black/[0.05] dark:divide-white/[0.05]">
                    {lista.map(p => (
                        <button key={p.id} type="button" onClick={() => onElegir(p)} className="w-full px-5 py-3 text-left flex items-center gap-3 active:bg-chip">
                            <div className="flex-1 min-w-0">
                                <p className="text-body font-black text-ink truncate">{p.cliente}</p>
                                <p className="text-caption text-muted truncate">{p.direccion || 'Sin dirección cargada'}</p>
                            </div>
                            <span className="text-caption font-bold text-muted shrink-0">{p.geo === 'PENDIENTE' ? 'Buscando…' : 'No encontrada'}</span>
                        </button>
                    ))}
                </div>
            </div>
        </div>
    );
}
